import axios from 'axios';
import settings from '../settings/index';
import {getToken} from '../helpers/utility';

export const Axios_Instance = axios.create({
  baseURL: settings.asset_mgmt_api,
});

Axios_Instance.defaults.headers = {
  Authorization: 'Bearer ' + getToken().get('idToken'),
};

const verifyError = (error) => {
  if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length >= 1) {
    return error.response.data.errors;
  }
  throw error;
};

export const doPost = (payload, url) => {
  return Axios_Instance.post(url, payload)
      .then((res) => res.data.data)
      .catch((error) => {
        return verifyError(error);
      });
};

export const doGet = (url) => {
  return Axios_Instance.get(url)
      .then((res) => res.data.data)
      .catch((error) => {
        return verifyError(error);
      });
};

export const doDownload = (url) => {
  return Axios_Instance.get(url, {responseType: 'blob'})
      .then((response) => {
        const fileName = response.headers['content-filename'];
        const blob = new Blob([response.data], {type: response.data.type});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return;
      }).catch((error) => {
        return verifyError(error);
      });
};

export const doDownloadNew = (url) => {
    return Axios_Instance.get(url, { responseType: 'blob' })
        .then((response) => {
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'download.csv';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }
            const blob = new Blob([response.data], { type: 'text/csv' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        })
        .catch(error => {
            console.error('Download error:', error);
        });
};

export const doPut = (payload, url) => {
  return Axios_Instance.put(url, payload)
      .then((res) => res.data.data)
      .catch((error) => {
        return verifyError(error);
      });
};

export const doDelete = (url) => {
  return Axios_Instance.delete(url)
      .then((res) => res.data.data)
      .catch((error) => {
        return verifyError(error);
      });
};

export const doPatch = (payload, url) => {
  return Axios_Instance.patch(url, payload)
      .then((res) => res.data.data)
      .catch((error) => {
        return verifyError(error);
      });
};
